import { render, staticRenderFns } from "./CommonWaterPaly.vue?vue&type=template&id=c3efd360&scoped=true"
import script from "./CommonWaterPaly.vue?vue&type=script&lang=js"
export * from "./CommonWaterPaly.vue?vue&type=script&lang=js"
import style0 from "./CommonWaterPaly.vue?vue&type=style&index=0&id=c3efd360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3efd360",
  null
  
)

export default component.exports